import { toFormFieldText } from '../../../shared/utils/formValue';

export const EMPTY_OUTSOURCING_FORM = {
  amount_jpy: '',
  note: '',
};

export function toOutsourcingForm(doc) {
  if (!doc) return { ...EMPTY_OUTSOURCING_FORM };
  return {
    amount_jpy: (
      doc.calculationStatus !== 'EMPTY' || doc.amountJpy > 0
        ? toFormFieldText(doc.amountJpy)
        : ''
    ),
    note: toFormFieldText(doc.note),
  };
}

export function toOutsourcingPayload(values) {
  return {
    amountJpy: Number(values.amount_jpy),
    note: values.note.trim(),
  };
}

export function isValidOutsourcingAmount(value) {
  const normalized = String(value ?? '').trim();
  return /^(0|[1-9][0-9]*)$/.test(normalized)
    && Number.isSafeInteger(Number(normalized));
}
